import { memo } from 'react';
import { Typography } from '@mui/material';

import { permission } from '../../const/commonConst';
import { UserInfoType } from '../../type/UserInfoType';
import theme from '../../../theme';

type UserInfoPropsType = {
	userInfo: UserInfoType;
};

// 権限IDにより権限名を選択する関数
const getPermissionLabel = (permissionNum: number) => {
	switch (permissionNum) {
		case permission.id.driver:
			return permission.label.driver;
		case permission.id.admin:
			return permission.label.admin;
		case permission.id.sales:
			return permission.label.sales;
		case permission.id.super:
			return permission.label.super;
		default:
			return permission.label.unknown;
	}
};

/**
 * ログインしたユーザ情報
 */
const LoginUserInfo = (props: UserInfoPropsType) => {
	const { userInfo } = props;

	const permissionLabel = getPermissionLabel(userInfo.permission);

	const loginUserInfoList = [
		{ label: userInfo.companyName, id: 'companyName' },
		{ label: userInfo.userName, id: 'userName' },
		{ label: permissionLabel, id: 'permission' },
	];

	return (
		<>
			{loginUserInfoList.map((loginUserInfo, index) => (
				<Typography
					role="lable"
					aria-label={loginUserInfo.label}
					id={loginUserInfo.id}
					key={index}
					noWrap
					sx={{
						fontSize: 15,
						fontWeight: 'bold',
						color: theme.palette.common.white,
						marginRight: 10,
					}}
				>
					{loginUserInfo.label}
				</Typography>
			))}
		</>
	);
};

export default memo(LoginUserInfo);
